// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightMiniReport-cls1_nKM","cls2":"CiterightMiniReport-cls2_BW5 CiterightMiniReport-cls1_nKM"};